export enum ticketLabels {
    TechnicalIssue,
    HRAdvisory
}
